// extracted by mini-css-extract-plugin
export default {"tabContent":"FaqAdBlue_tabContent__FXtJ6"};